import React from 'react';
import styled from 'styled-components';

import { media } from '../helpers';

const HeaderStylesContainer = styled.header`
    background-color: #f2f0eb;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 5000;
    border-bottom: 1px solid #000;
    .header-wrapper {
        display: flex;
        align-items: center;
        max-width: 100vw;

        .logo-container {
            flex: 1.5;
            display: flex;
            padding-left: 5vw;
            ${media.large`justify-content: center; padding-left: 0;`}

            a {
                display: inline-block;
                svg {
                    max-width: 150px;
                    width: 100%;
                    height: auto;

                    path {
                        fill: #000;
                    }
                }
            }
        }

        .primary-nav-container {
            flex: 3;
            display: none;
            ${media.large`display: block;`}
            nav.primary-nav {
                ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                    display: flex;
                    li {
                        flex: 0 0 25%;
                        a {
                            text-transform: uppercase;
                            font-weight: bold;
                            font-size: 0.9rem;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            padding: 25px;
                            text-decoration: none;
                            color: #000;
                            position: relative;
                            font-family: 'neue-kabel', sans-serif;

                            /* &.has-children {
                                &::after {
                                    display: inline-block;
                                    content: ' ';
                                    width: 0;
                                    height: 0;
                                    border-left: 15px solid transparent;
                                    border-right: 15px solid transparent;
                                    border-bottom: 15px solid white;
                                    position: absolute;
                                    bottom: 0;
                                }
                                &:hover {
                                    &::after {
                                        display: inline-block;
                                        opacity: 1;
                                    }
                                }
                            } */
                            /* &::after {
                                content: ' ';
                                width: 0px;
                                height: 0px;
                                border-left: 5px solid transparent;
                                border-right: 5px solid transparent;
                                border-bottom: 5px solid black;
                                display: block;
                                text-align: center;
                                margin: 10px auto 0px;
                                position: absolute;
                                left: 0px;
                                right: 0px;
                                opacity: 0;
                                transition: all 0.25s ease 0s;
                            } */

                            &:hover,
                            &.active {
                                color: #f74d33;
                                &::after {
                                    display: block;
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }
        }

        .secondary-nav-container {
            flex: 1.5;
            display: flex;
            justify-content: flex-end;
            ${media.large`justify-content: center;`}

            nav.secondary-nav {
                display: none;
                ${media.large`display: block;`}
                ul {
                    margin: 0;
                    padding: 0;
                    list-style: none;
                    display: flex;
                    justify-content: flex-end;
                    li {
                        margin-right: 45px;

                        &.cart-li {
                            button {
                                svg {
                                    width: 23px;
                                    height: 22px;
                                }
                            }
                        }
                        a {
                            font-size: 0.8rem;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            text-decoration: none;
                            color: #ff9905;
                            text-transform: uppercase;
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;

                            svg {
                                path {
                                    fill: #ff9905;
                                }
                            }
                        }
                        button {
                            font-family: sans-serif;
                            font-weight: bold;
                            font-size: 0.8rem;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            text-decoration: none;
                            color: #ff9905;
                            border: none;
                            background-color: transparent;
                            line-height: 1;
                            padding: 0;
                            svg {
                                path {
                                    fill: #ff9905;
                                }
                            }
                        }
                    }
                }
            }
            .mobile-nav {
                ${media.large`display: none;`}

                ul {
                    display: flex;
                    padding: 0;
                    margin: 0;
                    list-style: none;
                    align-items: center;

                    li {
                        margin-right: 20px;
                        ${media.small`margin-right: 30px;`}

                        &:last-child {
                            margin-right: 0px;
                        }

                        &.hamburger-container {
                            background: #f74d33;
                            padding: 16px;
                        }

                        .hamburger-react {
                            color: #fff;
                        }

                        button {
                            border: none;
                            background-color: transparent;
                            svg {
                                height: 25px;
                                width: 25px;
                            }
                        }
                        svg {
                            path {
                                fill: rgb(255, 153, 5);
                            }
                        }
                    }
                }
            }
        }
    }
`;

const HeaderStyles = ({ children }) => {
    return <HeaderStylesContainer>{children}</HeaderStylesContainer>;
};

const MegaMenuStylesContainer = styled.div`
    min-height: 330px;
    background-color: #f2f0eb;
    position: fixed;
    top: auto;
    left: 0;
    width: 100%;
    display: none;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #000;
    border-top: 1px solid #000;
    ${media.large`display: flex;`}
    .mega-menu-outer-wrapper {
        flex: 1;
        display: flex;
        align-items: center;
        ${media.medium`max-width: 100vw;`}
        .mm-nav-container {
            flex: 1.67;
            ul {
                margin: 0;
                padding: 0 0 0 8vw;

                list-style: none;
                li {
                    position: relative;

                    a {
                        font-weight: bold;
                        text-decoration: none;
                        color: #000;
                        display: inline-block;
                        width: 100%;
                        padding: 15px 0 15px 15px;
                        border-bottom: 1px solid #000;

                        &:hover,
                        &.active {
                            color: #f74d33;

                            &::after {
                                display: inline-block;
                            }
                        }
                    }

                    &:last-child {
                        a {
                            border-bottom: 0px;
                        }
                    }
                }
            }
        }
        .sub-navs-outer-container {
            flex: 4.5;

            .sub-nav-container {
                display: none;

                &.active {
                    display: flex;
                }

                nav {
                    display: flex;
                    align-self: center;
                    flex: 2.9;

                    .sub-nav {
                        padding: 0 0 0 1vw;
                        margin: 0;
                        list-style: none;
                        flex: 0 0 38%;
                        text-align: left;

                        &.first {
                            padding: 0 0 0 4vw;
                            ${media.laptop`padding: 0 0 0 4.1vw;`}
                        }

                        li {
                            margin-bottom: 10px;
                            &:last-child {
                                margin-bottom: 0px;
                            }

                            a {
                                color: #000;
                                font-weight: bold;
                                text-decoration: none;

                                &:hover {
                                    color: #f74d33;
                                }
                            }
                        }
                    }
                }
            }
            .image-container {
                flex: 1.5;
                padding: 0 9.5vw 0 1vw;
                border-left: 1px solid #000;
                display: flex;
                align-items: center;

                a {
                    display: inline-block;
                    width: 100%;
                    color: #000;
                    text-decoration: none;
                    font-weight: bold;

                    &:hover {
                        p {
                            opacity: 0.7;
                        }
                    }

                    .gatsby-image-wrapper {
                        flex: 1;
                        max-height: 235px;

                        img {
                            margin-bottom: 0px;
                        }
                    }

                    p {
                        margin: 10px 0 0;
                    }
                }
            }
        }
    }
`;

const MegaMenuStyles = ({ children }) => {
    return <MegaMenuStylesContainer>{children}</MegaMenuStylesContainer>;
};
export { MegaMenuStyles };
export default HeaderStyles;
